import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { 
  FiPlusCircle, 
  FiBriefcase, 
  FiFolder, 
  FiUsers, 
  FiArchive, 
  FiImage, 
  FiHome, 
  FiChevronDown, 
  FiChevronUp 
} from 'react-icons/fi';

import './css/admin.css';
import MerkezİlanForm from '../components/İlanPages/MerkezİlanForm';
import YurtIlanForm from '../components/İlanPages/YurtIlanForm';
import NevaYemekIlanForm from '../components/İlanPages/NevaYemekIlanForm';
import GMİncele from './Basvuru/GMİncele';
import YMİncele from './Basvuru/YMİncele';
import NevaYemekIncele from './Basvuru/NevaYemekIncele';
import ArsivBasvurular from './Basvuru/ArsivBasvurular';
import KariyerLogo from '../assets/kariyer_orj.png';
import JopArsiv from './JobManagement/JobArsiv';
import HomeAdmin from './HomeAdmin';
import AdminSlider from './Slider/AdminSlider';

function AdminPanel() {
  const location = useLocation();
  const [isJobMenuOpen, setIsJobMenuOpen] = useState(false);
  const [isApplicationsMenuOpen, setIsApplicationsMenuOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(
    location.state?.activeMenu || ''
  );

  const renderContent = () => {
    switch (selectedMenu) {
      case 'genelMerkezIlan':        return <MerkezİlanForm />;
      case 'yurtMudurlukleriIlan':   return <YurtIlanForm />;
      case 'nevaYemekIlan':          return <NevaYemekIlanForm />;
      case 'genelMerkezBasvuru':     return <GMİncele />;
      case 'yurtMudurlukleriBasvuru':return <YMİncele />;
      case 'nevaYemekBasvuru':       return <NevaYemekIncele />;
      case 'İlanArşivle':            return <JopArsiv />;
      case 'arsivBasvuru':           return <ArsivBasvurular />;
      case 'slider':                 return <AdminSlider />;
      default:                       return <HomeAdmin />;
    }
  };

  return (
    <div className="admin-layout">
      {/* Sol Sidebar */}
      <div className="admin-sidebar">
        <div className="sidebar-logo-area" onClick={() => setSelectedMenu('')}>
          <img src={KariyerLogo} alt="Kariyer Logo" />
        </div>

        <div className="sidebar-menu">
          {/* Ana Sayfa Linki */}
          <div 
            className={`menu-item-root ${selectedMenu === '' ? 'active' : ''}`}
            onClick={() => setSelectedMenu('')}
          >
            <div className="menu-left-block">
              <FiHome /> <span>Genel Durum</span>
            </div>
          </div>

          {/* Akordeon 1: İş İlanı Oluştur */}
          <div 
            className={`menu-item-root has-sub ${isJobMenuOpen ? 'open' : ''}`}
            onClick={() => setIsJobMenuOpen(!isJobMenuOpen)}
          >
            <div className="menu-left-block">
              <FiPlusCircle /> <span>İş İlanı Oluştur</span>
            </div>
            <div className="menu-arrow-block">
              {isJobMenuOpen ? <FiChevronUp /> : <FiChevronDown />}
            </div>
          </div>
          {isJobMenuOpen && (
            <ul className="sidebar-sub-menu">
              <li 
                className={selectedMenu === 'genelMerkezIlan' ? 'sub-active' : ''} 
                onClick={() => setSelectedMenu('genelMerkezIlan')}
              >
                Genel Merkez
              </li>
              <li 
                className={selectedMenu === 'yurtMudurlukleriIlan' ? 'sub-active' : ''} 
                onClick={() => setSelectedMenu('yurtMudurlukleriIlan')}
              >
                Yurt Müdürlükleri
              </li>
              <li 
                className={selectedMenu === 'nevaYemekIlan' ? 'sub-active' : ''} 
                onClick={() => setSelectedMenu('nevaYemekIlan')}
              >
                Neva Yemek
              </li>
            </ul>
          )}

          {/* Tek Link: İş İlanı Arşivle */}
          <div 
            className={`menu-item-root ${selectedMenu === 'İlanArşivle' ? 'active' : ''}`}
            onClick={() => setSelectedMenu('İlanArşivle')}
          >
            <div className="menu-left-block">
              <FiBriefcase /> <span>İş İlanları (Aktif)</span>
            </div>
          </div>

          {/* Akordeon 2: Başvuruları İncele */}
          <div 
            className={`menu-item-root has-sub ${isApplicationsMenuOpen ? 'open' : ''}`}
            onClick={() => setIsApplicationsMenuOpen(!isApplicationsMenuOpen)}
          >
            <div className="menu-left-block">
              <FiUsers /> <span>Başvuruları İncele</span>
            </div>
            <div className="menu-arrow-block">
              {isApplicationsMenuOpen ? <FiChevronUp /> : <FiChevronDown />}
            </div>
          </div>
          {isApplicationsMenuOpen && (
            <ul className="sidebar-sub-menu">
              <li 
                className={selectedMenu === 'genelMerkezBasvuru' ? 'sub-active' : ''} 
                onClick={() => setSelectedMenu('genelMerkezBasvuru')}
              >
                Genel Merkez
              </li>
              <li 
                className={selectedMenu === 'yurtMudurlukleriBasvuru' ? 'sub-active' : ''} 
                onClick={() => setSelectedMenu('yurtMudurlukleriBasvuru')}
              >
                Yurt Müdürlükleri
              </li>
              <li 
                className={selectedMenu === 'nevaYemekBasvuru' ? 'sub-active' : ''} 
                onClick={() => setSelectedMenu('nevaYemekBasvuru')}
              >
                Neva Yemek
              </li>
            </ul>
          )}

          {/* Tek Link: Arşiv Başvurular */}
          <div 
            className={`menu-item-root ${selectedMenu === 'arsivBasvuru' ? 'active' : ''}`}
            onClick={() => setSelectedMenu('arsivBasvuru')}
          >
            <div className="menu-left-block">
              <FiArchive /> <span>Arşiv Başvurular</span>
            </div>
          </div>

          {/* Tek Link: Slider */}
          <div 
            className={`menu-item-root ${selectedMenu === 'slider' ? 'active' : ''}`}
            onClick={() => setSelectedMenu('slider')}
          >
            <div className="menu-left-block">
              <FiImage /> <span>Slider Yönetimi</span>
            </div>
          </div>
        </div>
      </div>

      {/* Sağ İçerik Alanı */}
      <div className="admin-content-viewport">
        {renderContent()}
      </div>
    </div>
  );
}

export default AdminPanel;